import { useMemo } from 'react';

import {
  UseMultiAutocompleteProps,
  UseMultiDropdownProps,
} from '@adsk/alloy-react-dropdown';
import { keyBy, noop } from '@adsk/alloy-react-helpers';

import {
  DropdownProp,
  GroupedItem,
  ItemWithGroup,
  ItemWithOptionalLabel,
} from '../types';

export default (
  dropdownProps:
    | DropdownProp<UseMultiAutocompleteProps<ItemWithOptionalLabel>>
    | DropdownProp<UseMultiDropdownProps<ItemWithOptionalLabel>>,
  groupedItems: GroupedItem[],
  handleDisjointSelectedItems: (
    value: ItemWithOptionalLabel,
  ) => ItemWithOptionalLabel | void = noop,
) => {
  const { selectedItems, defaultSelectedItems, initialSelectedItems } =
    dropdownProps;

  return useMemo(() => {
    const getSelectedItems = (itemsToFilter: ItemWithOptionalLabel[]) => {
      const items = groupedItems.flatMap((groups) => groups.items);
      const itemsByValue = keyBy(items, 'value');

      const selectedItems: (ItemWithGroup | ItemWithOptionalLabel | void)[] =
        itemsToFilter.map(
          (item) =>
            itemsByValue[item.value] ?? handleDisjointSelectedItems(item),
        );

      return selectedItems.filter(Boolean);
    };

    if (selectedItems !== undefined) {
      return { selectedItems: getSelectedItems(selectedItems) };
    }
    if (defaultSelectedItems !== undefined) {
      return { defaultSelectedItems: getSelectedItems(defaultSelectedItems) };
    }
    if (initialSelectedItems !== undefined) {
      return { initialSelectedItems: getSelectedItems(initialSelectedItems) };
    }

    return {};
  }, [
    selectedItems,
    defaultSelectedItems,
    initialSelectedItems,
    groupedItems,
    handleDisjointSelectedItems,
  ]);
};
